import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { selectThemeMode, selectFontSize, selectFontWeight } from 'redux/appSlice';
import { AppBar, MenuDrawer, Copyright, PrivacyPolicyDialog } from 'components';
import themes from "../themes/Themes";
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box, Toolbar, Container, useTheme, useMediaQuery } from '@mui/material';
import { PublicOutlined } from '@mui/icons-material';

const APP_TITLE = process.env.REACT_APP_TITLE;
const SHORT_APP_TITLE = process.env.REACT_APP_TITLE_ACRONYM;

export default function DefaultLayout(props) {
    const theme = useTheme();
    const smallMediaScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const mode = useSelector(selectThemeMode);
    const fontSize = useSelector(selectFontSize);
    const fontWeight = useSelector(selectFontWeight);
    const { page } = props;
    const [open, setOpen] = useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    return (
        <ThemeProvider theme={themes.light(fontSize, fontWeight)}>
            <Box className={mode} sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar open={open} login title={<span>{smallMediaScreen ? APP_TITLE : SHORT_APP_TITLE} <PublicOutlined fontSize='small' /> </span>} toggleDrawer={toggleDrawer} />
                <MenuDrawer open={open} selectedItem={page.type.name} />
                <Box
                    component="main"
                    sx={{
                        backgroundColor: theme.palette.grey[100],
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}
                >
                    <Toolbar />
                    <Container maxWidth={false} sx={{ flexGrow: 1 }}>
                        {page}
                    </Container>
                    <Copyright />
                </Box>
                <PrivacyPolicyDialog />
            </Box>
        </ThemeProvider>
    );
};